/**
 * Module for managing various OST caches.
 */
export default class OstCacheManager {
  constructor() {
    this._readOnlyBasketsCache = new Map();
    this._writtableBasketsCache = new Map();
    this._supportCache = new Map();
  }

  /**
   *
   * @param {OstCache} cache
   */
  setCache(cache) {
    if (cache.readOnlyData) {
      this._readOnlyBasketsCache.set(cache.subscriptionId, cache);
    } else {
      this._writtableBasketsCache.set(cache.subscriptionId, cache);
    }
  }

  /**
   *
   * @param {string} subscriptionId
   * @returns {?OstCache}
   */
  getReadOnlyCache(subscriptionId) {
    return this._readOnlyBasketsCache.get(subscriptionId) || null;
  }

  /**
   *
   * @param {string} subscriptionId
   * @returns {?OstCache}
   */
  getWritableCache(subscriptionId) {
    return this._writtableBasketsCache.get(subscriptionId) || null;
  }

  /**
   *
   * @param {string} subscriptionId
   * @param {{isSupported: "Y"|"N", reason: "OLD"|"NEW"|"FUTURE"}} ostSupportCache
   */
  setSupportCache(subscriptionId, ostSupportCache) {
    this._supportCache.set(subscriptionId, ostSupportCache);
  }

  /**
   *
   * @param {string} subscriptionId
   * @returns {isSupported: "Y"|"N", reason: "OLD"|"NEW"|"FUTURE"}
   */
  getSupportCache(subscriptionId) {
    return this._supportCache.get(subscriptionId) || null;
  }

  /**
   * Used to clear caches for subscriptionId after order submit
   *
   * @param {string} subscriptionId
   */
  clear(subscriptionId) {
    this._writtableBasketsCache.delete(subscriptionId);
    this._readOnlyBasketsCache.delete(subscriptionId);
  }
}
